import { render, staticRenderFns } from "./VMainNavItemBottom.vue?vue&type=template&id=113b9ae4&"
import script from "./VMainNavItemBottom.vue?vue&type=script&lang=js&"
export * from "./VMainNavItemBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports